<template>
    <div class="panel panel-default">
        <div v-bind:id="data.id + 'PanelHeading'" class="panel-heading clearfix" v-on:click="togglePanel" role="button">
            <span class="panel-controls pull-right">
                <div class="badge" v-show="count">{{ count }}</div>
                <i class="icon icon-ctrl" v-bind:class="{ 'icon-down' : count, 'icon-up' : !count }"></i>
            </span>

            <h3 class="panel-title"><i v-bind:class="'icon ' + data.icon"></i>{{ data.title }}</h3>
        </div>

        <div class="panel-collapse collapse" v-bind:class="{ 'in' : count }" role="tabpanel" v-bind:aria-labelledby="data.id + 'PanelHeading'">
            <datatable v-if="data.id != 'emailaccount'" :data="data"></datatable>
            <email-account v-if="data.id == 'emailaccount'" :accounts="accounts"></email-account>
        </div>
    </div>
</template>

<script>
    var Datatable = require('./datatable.vue').default;

    export default
    {
        props: {
            data: { default: {
                id: 'null'
            } },
            accounts: { default: '' }
        },

        data: function() {
            return {
                loading: true,
                count: 0,
                rows: []
            };
        },

        created() {
            this.$eventHub.$on('countUpdate' + this.data.id, this.countUpdate);
        },

        methods : {
            countUpdate: function(count) {
                this.count = count;
            },
            newItem: function () {
                var url = this.data.url + '/create';
                // Load Modal
                if(this.data.modal){
                    $('#boldModal').modal({
                        remote: url
                    });
                    return;
                }
                // Load Page Directly
                window.location = url;
            },
            togglePanel: function () {
                myToggle2(this.data.id);
            }
        },
        components:{
            'datatable': Datatable,
            'email-account': require('../components/email-account.vue').default
        }
    };
</script>